
import SectionModel from '../../models/sectionModel';
import {
    CONTROL_TYPE,
    MODEL_CONTROL_TYPE,
    ORDERING_MENU_TYPE_SECTION_MODEL,
    TYPE_SECTION_DEPOT_MODEL,
} from '../../utils/enums';
import { createBreadcrumbModel } from '../createBreadcrumbModel';
import { createControlModel, filtrateControlByDepotRole } from '../controlModelFactory';
import { getHistoryLocationParams } from '../../utils/routesHelper';
import {
    getDepotNameById,
    getDepots,
} from '../restaurant';
import { ORDERING_MENU_FOLLOW_UP, ORDERING_MENU_GET } from '../../store/reducers/restaurant/restaurant-actions';

export function createDepotBusinessFollowUpEditSectionModel({ ...args }) {
    return new SectionModel({
        columns: [
            {
                isEditable: true,
                type: CONTROL_TYPE.sectionGroup,
                items: [
                    {
                        title: "settings.follow_up.ENABLED",
                        accessor: "enabled",
                        type: CONTROL_TYPE.switch,
                        isInline: true,
                        isEditable: true,
                    },
                    {
                        title: "settings.follow_up.WAIT_TIME",
                        accessor: "validity_time",
                        type: CONTROL_TYPE.number,
                        isInteger: true,
                        isEditable: true,
                    },
                    {
                        title: "settings.follow_up.FREE_DELIVERY",
                        accessor: "free_delivery",
                        type: CONTROL_TYPE.switch,
                        isInline: true,
                        isEditable: true,
                    },
                    {
                        title: "settings.follow_up.ENABLE_BY_RADIUS",
                        accessor: "no_minimal_order",
                        type: CONTROL_TYPE.switch,
                        isInline: true,
                        isEditable: true,
                    },
                    {
                        title: "settings.follow_up.RADUIS",
                        accessor: "applicable_business_radius",
                        type: CONTROL_TYPE.number,
                        isInteger: true,
                        isEditable: true,
                    },
                ],
            },
            {
                title: 'settings.follow_up.BUSINESS_ITEMS_HEADER_LABEL',
                isEditable: true,
                type: CONTROL_TYPE.sectionGroup,
                items: [
                    {
                        title: 'settings.listPromotion.BUSINESS_ADD_BUTTON',
                        accessor: 'applicable_business_list',
                        connect: state => {
                            const depots = (state.restaurant.data && state.restaurant.data.depots) || [];
                            return {
                                values: depots
                                    .filter(depot => depot.businessId)
                                    .map(depot => ({ key: depot.businessId, value: depot.name })),
                            };
                        },
                        values: function (item) {
                            return getDepots()
                                .filter(
                                    depot =>
                                        depot.businessId &&
                                        !(item.business_ids || []).find(f => f.key === depot.businessId)
                                )
                                .map(depot => ({ key: depot.businessId, value: depot.name }));
                        },
                        isEditable: true,
                        type: CONTROL_TYPE.selectWithAdd,
                    },
                    {
                        accessor: 'applicable_business_list',
                        itemValue: {
                            key: 'key',
                            accessor: 'value',
                            isReadonly: true,
                        },
                        isReadonly: true,
                        isEditable: true,
                        isDraggable: true,
                        type: CONTROL_TYPE.listItem,
                    },
                ],
            },
        ],
        initNewItemModel: item => {
            return item;
        },
        label: "settings.follow_up.LABEL",
        breadcrumbs: [
            createBreadcrumbModel({
                label: "settings.map.DEPOT_SETTINGS_LABEL"
            }),
            createBreadcrumbModel({
                getLabel: () => {
                    const { id } = getHistoryLocationParams(window.location.search);
                    return getDepotNameById(id);
                }
            })
        ],
        controls: filtrateControlByDepotRole([
            createControlModel({
                type: MODEL_CONTROL_TYPE.back,
            }),
        ]),
        actionName: ORDERING_MENU_FOLLOW_UP,
        actionLoad: ORDERING_MENU_GET,
        typeAction: args.typeAction,
        typeModel: ORDERING_MENU_TYPE_SECTION_MODEL.orderingMenuFolowUp,
        parentUrl: TYPE_SECTION_DEPOT_MODEL.depotsEdit,
        stayAfterSave: true,
        mappingLambda: state => {
            const depots = state.restaurant?.data?.depots || [];
            const followUp = state.restaurant.data?.businessMenu?.follow_up_order || {};
            if(depots.length && followUp) {
                return {...followUp, applicable_business_list: (followUp?.applicable_business_list || []).map(id => {
                    const depot = (depots.find(depot => depot.businessId === id) || {});
                    if(!depot) return {key: id, value: id}; 
                    return {key: depot.businessId, value: depot.name};
                })}
            }
            return followUp;
        },
    });
}
